import { useState } from "react";
import { api, formatErr, CATEGORIE_LABELS } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Wand2, Trash2 } from "lucide-react";
import { toast } from "sonner";

const nomeMese = (m) => new Date(`${m}-01T12:00`).toLocaleDateString("it-IT", { month: "long", year: "numeric" });

export const RegoleDialog = ({ company, mese, writable }) => {
  const [open, setOpen] = useState(false);
  const [regole, setRegole] = useState([]);
  const [dubbie, setDubbie] = useState([]);
  const single = company !== "all";
  const load = () => api.get("/regole-banca", { params: { company } }).then((r) => setRegole(r.data));
  const apri = () => { setOpen(true); setDubbie([]); if (single) load(); };
  const impara = async () => {
    try {
      const { data } = await api.post("/regole-banca/impara", { company, mese });
      setDubbie(data.dubbie);
      toast.success(`Regole imparate da ${nomeMese(mese)}: ${data.imparate}`);
      load();
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  const del = async (id) => {
    try { await api.delete(`/regole-banca/${id}`); load(); } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  return (
    <>
      <Button size="sm" variant="outline" className="h-8 gap-1" onClick={apri} data-testid="pn-regole-button">
        <Wand2 className="w-4 h-4" />Regole
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle>Regole automatiche degli estratti conto</DialogTitle></DialogHeader>
          {!single ? <div className="text-sm text-muted-foreground">Scegli un'azienda in alto per vedere le sue regole.</div> : <>
            <div className="text-xs text-muted-foreground -mt-2">
              Quando assegni una riga di banca a un padroncino o ad AZIENDA, l'app se lo ricorda per quel nome o fornitore. Al prossimo import le righe uguali vengono assegnate da sole (gli incassi restano da verificare).
            </div>
            {writable && <Button size="sm" className="h-8 gap-1 w-fit" onClick={impara} data-testid="regole-impara">
              <Wand2 className="w-4 h-4" />Impara da {nomeMese(mese)}</Button>}
            {dubbie.length > 0 && <div className="text-xs text-orange-600" data-testid="regole-dubbie">
              Non imparate perché assegnate in modi diversi nello stesso mese: {dubbie.join(", ")}</div>}
            <table className="autotrans-table w-full" data-testid="regole-table">
              <thead><tr><th>Nome / fornitore</th><th>Verso</th><th>Assegna a</th><th>Categoria</th><th>Descrizione</th><th></th></tr></thead>
              <tbody>
                {regole.map((r) => (
                  <tr key={r.id} data-testid={`regola-${r.id}`}>
                    <td>{r.controparte}</td>
                    <td>{r.chiave.startsWith("E:") ? "entrata" : "uscita"}</td>
                    <td className="font-semibold">{r.padroncino}</td>
                    <td>{CATEGORIE_LABELS[r.categoria] || r.categoria}</td>
                    <td className="text-xs">{r.descrizione || "—"}</td>
                    <td>{writable && <Button size="icon" variant="ghost" className="h-6 w-6 text-destructive" onClick={() => del(r.id)} data-testid={`regola-del-${r.id}`}><Trash2 className="w-3 h-3" /></Button>}</td>
                  </tr>
                ))}
                {regole.length === 0 && <tr><td colSpan={6} className="text-center py-3 text-muted-foreground">Nessuna regola ancora</td></tr>}
              </tbody>
            </table>
          </>}
        </DialogContent>
      </Dialog>
    </>
  );
};
